import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  setEventsError,
  setEventsResults,
  setEventsStatus,
} from './eventsSlice';
import { getFocusOnlineEvents } from '../../services/onlineEventService';

export const getEvents = createAsyncThunk(
  'events/getFocusEvents',
  async (_never: never, { dispatch }) => {
    try {
      dispatch(setEventsStatus('loading'));
      const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
      const results = await getFocusOnlineEvents(timeZone);
      dispatch(setEventsResults(results));
      dispatch(setEventsStatus('idle'));
    } catch (error) {
      dispatch(
        setEventsError(error instanceof Error ? error.message : 'Search failed')
      );
      dispatch(setEventsStatus('failed'));
      throw error;
    }
  }
);

export default {
  getEvents,
};
